import { createFileRoute } from '@tanstack/react-router'
import { SuperAdminBlogDomains } from '@/views/super-admin/blog_domains'

export const Route = createFileRoute('/_authenticated/super-admin-blog-domains')({
    component: SuperAdminBlogDomains,
})
